import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import axios from 'axios';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { getToken } from './utils/LoginManager'

if (process.env.NODE_ENV === 'development') { 
    axios.defaults.baseURL = 'http://sigaweb3.local/api';
} else {
    axios.defaults.baseURL = '/api';
}
axios.interceptors.request.use(request => {
    request.headers.Authorization = 'Bearer ' + getToken();     
    return request;
})

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js